import { findDefaultRoleKey, requireAnySystemPermission } from '../../../../backend/features/permissions/shared';
export function getContactManagementFormConfigRules(t, settings, userState) {
    const rules = [
        {
            type: 'showOnlyInPublicRegistrationPage',
            label: t('contact-management:rules.showOnlyInPublicRegistrationPage'),
            applyRule: (config, data, formParams) => {
                config.hidden = (formParams === null || formParams === void 0 ? void 0 : formParams.page) !== 'public-registration';
            },
        },
        {
            type: 'hideInPublicRegistrationPage',
            label: t('contact-management:rules.hideInPublicRegistrationPage'),
            applyRule: (config, data, formParams) => {
                config.hidden = (formParams === null || formParams === void 0 ? void 0 : formParams.page) === 'public-registration';
            },
        },
        {
            type: 'hideIfNoActiveOrganizationType',
            label: t('contact-management:rules.hideIfNoActiveOrganizationType'),
            applyRule: (config, _data, formParams) => {
                config.hidden = (formParams === null || formParams === void 0 ? void 0 : formParams.organizationsTypeLength) === 0 || (formParams === null || formParams === void 0 ? void 0 : formParams.organizationsTypeLength) === undefined;
            },
        },
        {
            type: 'disabledForOtherAccounts',
            label: t('contact-management:rules.disabledForOtherAccounts'),
            applyRule: (config, data, formParams) => {
                // TODO this is most likely bad
                const enabled = formParams
                    ? formParams.page === 'transfer' ||
                        formParams.page === 'details' ||
                        formParams.page === 'login-completion' ||
                        formParams.page === 'public-registration' ||
                        formParams.page === 'new' ||
                        (formParams.page === 'profile' && formParams.id === (userState === null || userState === void 0 ? void 0 : userState.id))
                    : true;
                config.disabled = !enabled;
            },
        },
        {
            type: 'hiddenForOtherAccounts',
            label: t('contact-management:rules.hiddenForOtherAccounts'),
            applyRule: (config, data, formParams) => {
                const hidden = formParams
                    ? formParams.page === 'transfer' ||
                        formParams.page === 'details' ||
                        formParams.page === 'login-completion' ||
                        formParams.page === 'public-registration' ||
                        formParams.page === 'new' ||
                        (formParams.page === 'profile' && formParams.id === (userState === null || userState === void 0 ? void 0 : userState.id))
                    : true;
                config.hidden = !hidden;
            },
        },
        {
            type: 'showOnlyForAdministrators',
            label: t('contact-management:rules.showOnlyForAdministrators'),
            applyRule: (config) => {
                console.warn('showOnlyForAdministrators rule is deprecated, you should write your own rule, that checks specific permission');
                config.hidden = !requireAnySystemPermission(userState, 'all-organizations-admin');
            },
        },
        {
            type: 'enabledOnlyInAccountRegistration',
            label: t('contact-management:rules.enabledOnlyInAccountRegistration'),
            applyRule: (config, data, formParams) => {
                config.disabled = (formParams === null || formParams === void 0 ? void 0 : formParams.page) !== 'public-registration' && (formParams === null || formParams === void 0 ? void 0 : formParams.page) !== 'new';
            },
        },
        {
            type: 'validateAccountCompletion',
            label: t('contact-management:rules.validateAccountCompletion'),
            applyRule: () => {
                // This rule is just a marker for now
            },
        },
        {
            type: 'validateAccountLogin',
            label: t('contact-management:rules.validateAccountLogin'),
            applyRule: () => {
                // This rule is just a marker for now
            },
        },
        {
            type: 'disableNotVisibleOrganizationsInOrganizationSharing',
            label: t('contact-management:rules.disableNotVisibleOrganizations'),
            applyRule: (config) => {
                config.disableNotVisible = !requireAnySystemPermission(userState, 'view-invisible-organizations');
            },
        },
    ];
    if (settings) {
        rules.push({
            type: 'systemStatusVisibilityBasedOnSystemRole',
            label: t('contact-management:rules.systemStatusVisibilityBasedOnSystemRole'),
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            applyRule: (config, data) => {
                if (!userState) {
                    config.hidden = true;
                }
                else {
                    const userRole = settings.systemRoleMap[userState.systemRole];
                    const selectedRole = settings.systemRoleMap[data === null || data === void 0 ? void 0 : data.systemRole];
                    if (userRole && selectedRole && selectedRole.level > userRole.level) {
                        config.disabled = true;
                    }
                    else {
                        config.disabled = false;
                    }
                }
            },
        });
        rules.push({
            type: 'systemRoleVisibility',
            label: t('contact-management:rules.systemRoleVisibility'),
            applyRule: (config, data, formParams) => {
                if (!userState) {
                    config.hidden = true;
                }
                else {
                    if (requireAnySystemPermission(userState, 'change-account-systemRole')) {
                        const userRole = settings.systemRoleMap[userState.systemRole];
                        const selectedRole = settings.systemRoleMap[data === null || data === void 0 ? void 0 : data.systemRole];
                        if ((selectedRole === null || selectedRole === void 0 ? void 0 : selectedRole.level) > (userRole === null || userRole === void 0 ? void 0 : userRole.level)) {
                            config.values = Object.entries(settings.systemRoleMap).map(([roleKey, role]) => ({
                                label: role.label,
                                value: roleKey,
                            }));
                            config.disabled = true;
                            return;
                        }
                        config.values = Object.entries(settings.systemRoleMap)
                            .filter(([, role]) => role.level <= userRole.level)
                            .map(([roleKey, role]) => ({
                            label: role.label,
                            value: roleKey,
                        }));
                        config.disabled = false;
                    }
                    else {
                        config.disabled = true;
                    }
                    if ((formParams === null || formParams === void 0 ? void 0 : formParams.page) === 'new') {
                        config.defaultValue = findDefaultRoleKey(settings.systemRoleMap);
                    }
                }
            },
        });
        rules.push({
            type: 'organizationSharing',
            label: t('contact-management:rules.organizationSharing'),
            applyRule: (config, 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            data, 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            formParams) => {
                if (userState) {
                    config.sharingOptions = [
                        ...(formParams.createdBy === (userState === null || userState === void 0 ? void 0 : userState.id)
                            ? [
                                {
                                    type: 'private',
                                    icon: 'material-person',
                                    label: t('panels.groups.onlyMyself'),
                                },
                            ]
                            : []),
                        ...(formParams.createdBy !== (userState === null || userState === void 0 ? void 0 : userState.id) &&
                            requireAnySystemPermission(userState, 'all-organizations-admin', 'manage-groups')
                            ? [
                                {
                                    type: 'private',
                                    icon: 'material-person',
                                    label: formParams.ownerDisplayName
                                        ? t('panels.groups.onlyOwnerName', { name: formParams.ownerDisplayName })
                                        : t('panels.groups.onlyMyself'),
                                },
                            ]
                            : []),
                        {
                            type: 'any-admin',
                            icon: 'material-groups',
                            label: t('panels.groups.anyAdmin'),
                        },
                        ...(settings.organizationsEnabled
                            ? [
                                {
                                    type: 'organizations',
                                    icon: 'material-group-add',
                                    label: t('panels.groups.selectedAdmins'),
                                },
                            ]
                            : []),
                    ];
                }
            },
        });
        rules.push({
            type: 'showWhenUsingConsentlessTexting',
            label: t('contact-management:rules.showWhenUsingConsentlessTexting'),
            applyRule: (config) => {
                config.hidden = !settings.useConsentlessTexting;
            },
        });
        rules.push({
            type: 'maxNumberOfMembershipsPerOrgTree',
            label: t('contact-management:rules.maxNumberOfMembershipsPerOrgTree'),
            applyRule: (config, data) => {
                config.hidden = !settings.accountMembershipLimitPerOrgSubTreeEnabled || !!data.parentId;
            },
        });
    }
    return rules;
}
